//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { IUnisonDateRange } from '@models/UnisonTypes';

export const getSessionInfo = (state: ICuralateStore) => state.session;

export const getClientCreationDate = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.client.createdTimestamp,
);

export const getClientName = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.client.name,
);

export const getDateRange = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.dateRange,
);

export const getUnisonDateRange = createSelector(
  getDateRange,
  (dateRange): IUnisonDateRange => ({
    startDate: new Date(dateRange.from),
    endDate: new Date(dateRange.to),
    alias: 'custom',
  }),
);

export const getUserEmail = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.user.email,
);

export const getClientContractMRR = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.client.contractMRR,
);

export const getUserId = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.user.id,
);

export const getCurrentUser = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.user,
);

export const getIsSyndicationClient = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.client.isSyndication,
);

export const getIsCuralateEmployee = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.internalInfo.isCuralateEmployee,
);

export const getIsShareV2Vendor = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.client.isShareV2Vendor,
);
